import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ResponseCodeService} from "../../../../services/response-code.service";
import {NotificationService} from "../../../../services/notification.service";
import {AppState} from "../../../reducers";
import {Store} from "@ngrx/store";
import {Apollo} from "apollo-angular";
import {map, switchMap} from "rxjs/operators";

import * as fromActions from './service-category.actions'
import * as fromGraphql from './service-category.graphql'


@Injectable()
export class ServiceCategoryEffects {

  createServiceCategory = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_CATEGORY,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceCategory({ serviceCategory: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServiceCategory$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_CATEGORY,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceCategory({ serviceCategory: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceCategory$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_CATEGORY,
        variables: {
          categoryUniqueId: action?.categoryUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceCategory({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceCategories),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_CATEGORIES,
        variables:{filtering:action.filtering},
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceCategorys({ serviceCategorys: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
